import React, { useMemo, useState } from "react";
import { format } from "date-fns";
import Table from "../../../components/ui/table/Table";
import { downloadLoader } from "../../../assetData/loaders";

const BhavConfig = ({ tableData, loading }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "trading_date",
        header: "Trading Date",
        sortingFn: "datetime",
        Cell: ({ row }) =>
          format(new Date(row.original.trading_date), "dd MMM yyyy"),
      },
      {
        accessorKey: "settlement_nbr",
        header: "Settlement #",
        filterFn: "equals",
        // mantineTableHeadCellProps: { align: "right" },
        // mantineTableBodyCellProps: { align: "right" },
      },
      {
        accessorKey: "settlement_nbr_delivery",
        header: "Settlement Delivery #",
        filterFn: "equals",
      },
      {
        accessorKey: "settlement_date",
        header: "Settlement Date",
        sortingFn: "datetime",
        Cell: ({ row }) =>
          format(new Date(row.original.settlement_date), "dd MMM yyyy"),
      },
      {
        accessorKey: "settlement_nbr",
        header: "Settlement #",
        filterFn: "equals",
      },
      {
        accessorKey: "entry_for_6A_7A_data",
        header: "6A 7A Entry Date",
        sortingFn: "datetime",
        Cell: ({ row }) =>
          format(new Date(row.original.entry_for_6A_7A_data), "dd MMM yyyy"),
      },
      {
        accessorKey: "confirmation_of_6A_7A_data_custodian",
        header: "6A 7A Confirmation Date",
        sortingFn: "datetime",
        Cell: ({ row }) =>
          format(
            new Date(row.original.confirmation_of_6A_7A_data_custodian),
            "dd MMM yyyy",
          ),
      },
      {
        accessorKey: "auction_settlement_nbr",
        header: "Auction Settlement #",
        filterFn: "equals",
      },
      {
        accessorKey: "submission_of_auction_offers_date",
        header: "Auction Submission Date",
        sortingFn: "datetime",
        Cell: ({ row }) =>
          format(
            new Date(row.original.submission_of_auction_offers_date),
            "dd MMM yyyy",
          ),
      },
      {
        accessorKey: "auction_settlement_date",
        header: "Auction Settlement Date",
        sortingFn: "datetime",
        Cell: ({ row }) =>
          format(new Date(row.original.auction_settlement_date), "dd MMM yyyy"),
      },
    ],
    [tableData],
  );

  return (
    <Table
      tableData={tableData}
      columns={columns}
      loading={loading}
      pageName={"Bhav"}
      userId={JSON.parse(sessionStorage.getItem("user"))?.userId}
    />
  );
};

export default BhavConfig;
